import request from '@/http'
// const urls = 'http://192.168.2.42:9999'
let url = process.env.VUE_APP_APIMATERIALS
let url1 = process.env.VUE_APP_APITEAM
let shebeiUrl = process.env.VUE_APP_SHEBEIAPI
const apiMaterials= process.env.VUE_APP_LOGINAPI +process.env.VUE_APP_ENTERPRISE
export const apiResignAll = {
  getEquList: (data) => request.get(`/equipment/list?page=${data.page}&limit=${data.limit}&searchName=${data.searchName}&basicInfoNo=${data.basicInfoNo}`), // 设备列表
  chooseEquipment: (data) => request.get(`/teamInfo/chooseEquipment?page=${data.page}&limit=${data.limit}&searchName=${data.searchName}&basicInfoNo=${data.basicInfoNo}`), // 设备列表
  EditorEqu: (params) => request.post('/equipment', params), // 新增、编辑
  DeleteEqu: (id) => request.delete(`/equipment/${id}`), // 删除

  getCertificateList: (data) => request.get(`/certificate/list?page=${data.page}&limit=${data.limit}`), // 获取证书列表
  EditorCert: (params) => request.post('/certificate', params), // 新增编辑
  DeleteCert: (id) => request.delete(`/certificate/${id}`), // 删除

  SaveTeamInfo: (params) => request.post('/teamInfo', params), // 保存团队需求信息
  DeleteTeamInfo: (id) => request.delete(`/teamInfo/${id}`), // 保存团队需求信息
  GetTeamInfo: (params) => request.get(`/teamInfo/list?teamSize=${params.teamSize}&teamStatus=${params.teamStatus}&contact=${params.contact}&page=${params.page}&limit=${params.limit}&firstCategoryNo=${params.firstCategoryNo}&secondCategoryNo=${params.secondCategoryNo}&thirdCategoryNo=${params.thirdCategoryNo}`), // 保存团队需求信息
  TeamInfoEdit: (no) => request.get(`/teamInfo/edit/${no}`), // 获得编辑工队信息
  // TeamInfoEdits: (companyNo, userNo) => request.get(`/teamInfo/edit?companyNo=${companyNo}&userNo=${userNo}`), // 获得工队信息已废
  TeamInfoDetail: (companyNo) => request.get(url + `/companyInfo/getGoodsCompanyInfoDetails?companyNo=${companyNo}`), // 获得企业详情
  TeamInfoDetails: (no) => request.get(`/teamInfo/teamDetail/${no}`), // 获得工队详情
  teamDetailEquipmentList: (data) => request.get(`/teamInfo/teamDetail/equipmentList?page=${data.page}&limit=${data.limit}&no=${data.basicInfoNo}`), // 获得工队详情设备信息
  recommendList: (obj) => request.get(`/teamInfo/recommendList?provinceNo=${obj.id}&companyNo=${obj.companyNo}&userNo=${obj.userNo}`), // 推荐工队
  newSettledList: (id) => request.get(`/teamInfo/newSettled?location=${id}`), // 最新入驻
  // teamInfoSearchList: (params,data) => request.post(`/teamInfo/search?page=${params.page}&limit=${params.limit}`,data), // 筛选搜索列表
  // teamInfoSearchList: (data) => request.post(`/teamInfo/search`, data), // 筛选搜索列表
  teamInfoSearchList: (data) => request.post(`/teamInfo/new/search`, data), // 筛选搜索列表v2.1.6更改
  teamInfoSearchListNew: (params, data) => request.post(`/teamPrice/findPriceList`, data), // 筛选搜索列表
  getrecommendList: (data) => request.post(`/teamPrice/recommendList`, data), // 工种报价详情页相关推荐列表
  // teamInfoSearchListNew: (params, data) => request.get(`/teamPrice`, data), // 筛选搜索列表
  findTeam: (params, data) => request.get(`/demandCenter/findTeam`, data), // 筛选搜索列表
  findWork: (params, data) => request.post(`/demandCenter/findJob`, data), // 筛选搜索列表
  demandCenterDetail: (no, type) => request.get(`/demandCenter/detail?no=${no}&type=${type}`), // 筛选搜索列表
  demandCenterRelevant: (params, data) => request.get(`/demandCenter/relevant/` + params, data), // 筛选搜索列表

  getLocation: () => request.get('/sysArea/getAllArea'), // 获得地区信息

  getTeamResults: (data) => request.get(`/teamResults/list`, data), // 团队业绩列表
  SaveteamResults: (params) => request.post('/teamResults', params), // 团队业绩添加、编辑
  DeleteamResults: (id) => request.delete(`/teamResults/${id}`), // 删除团队业绩

  getTeamPerson: (data) => request.get('/teamMembers/list', data), // 人员列表
  SaveteamPerson: (params) => request.post('/teamMembers', params), // 人员添加、编辑
  DeleteamPerson: (id) => request.delete(`/teamMembers/${id}`), // 删除人员

  getequipmentList: (data) => request.get('/equipment/findByTeamNo', data), // 设备列表
  SaveequipmentList: (params) => request.post('/teamInfo/saveEquipments', params), // 自有设备添加、编辑
  DeletequipmentList: (id) => request.delete(`/teamInfo/equipmentList/${id}`), // 删除自有设备

  // getTeamteamPrice: (data) => request.get(`/teamPrice/list?page=${data.page}&limit=${data.limit}&basicInfoNo=${data.basicInfoNo}`), // 施工报价列表
  getTeamteamPrice: (data) => request.get(`/teamPrice/findByTeamNoList`, data), // 施工工队-工种报价列表
  SaveteamteamPrice: (params) => request.post('/teamPrice', params), // 施工报价添加、编辑
  DeleteamteamPrice: (id) => request.delete(`/teamPrice/${id}`), // 删除施工报价
  getTeamEditInfo: (id) => request.get(`/teamPrice/editInfo?no=${id}`),
  PriseInfoDetail: (no) => request.get(`/teamPrice/priceDetail?no=${no}`), // 获得报价详情
  PriserecommendList: (obj) => request.get(`/teamPrice/recommendList?provinceNo=${obj.id}&no=${obj.no}`), // 推荐报价

  GetEngineeringInfoList: (params) => request.get(`/engineeringInfo/list?contact=${params.contact}&page=${params.page}&limit=${params.limit}&firstCategoryNo=${params.firstCategoryNo}&secondCategoryNo=${params.secondCategoryNo}&thirdCategoryNo=${params.thirdCategoryNo}`), // 获取我的工程
  SaveEngineering: (params) => request.post('/engineeringInfo', params), // 发布工程信息
  SaveEngineerRequirement: (params) => request.post('/engineeringInfo/Requirement', params), // 发布团队要求
  DeleEngineering: (id) => request.delete(`/engineeringInfo/${id}`), // 删除发布工程
  EngineeringInfoEdit: (no) => request.get(`/engineeringInfo/edit/${no}`), // 编辑获取发布工程信息

  GetalbumList: (data) => request.get(`/album/List?page=${data.page}&limit=${data.limit}`), // 获取视频相册
  SavealbumList: (params) => request.post('/album/add', params), // 保存视频相册
  Deletealbum: (id) => request.delete(`/album/${id}`), // 删除

  GetfindAlbumByTeamNo: (no) => request.get(`/album/findAlbumByTeamNo?no=${no}`), // 获取详情页中视频相册

  gettaxRateOption: () => request.get(`/rate/findAll`), // 获取税率
  getteamSizeOption: (type) => request.get(`/teamSize/findAll?type=${type}`), // 获取团队规模

  getTeamCategory: () => request.get(`/api/index/getTeamCategory`), // 获取业务范围团队类目
  // getEngineeringCategory: () => request.get(`/sysEngineeringCategory/getList?name=&page=1&limit=10000`), // 获取工程类目
  getEngineeringCategory: () => request.get(`/sysEngineeringCategory/findCategoryListTree`), // 获取工程类目
  getPayWay: () => request.get(`sysPayWay/getComboBox`), // 获取筛选付款方式

  // getOccupationConfig: (params) => request.get(`/occupationConfig`, params),//获得工种列表
  getOccupationConfig: (params) => request.get(`/occupationConfig/getComboBox`, params), // 获得工种列表
  // getEquipmentConfig: (params) => request.get(`/equipmentConfig`, params) //获得拥有设备
  getEquipmentConfig: (params) => request.get(`/equipmentConfig/getComboBox`, params), // 获得拥有设备
  getIsEnable: (no) => request.get(`/laborEmployment/getCurrentInfo/${no}`),//是否禁用数据
  getSaveForBid: (params) => request.post(`/addEnquire`, params), // 新增函询
  getAreaListData: () => request.get(shebeiUrl + `/api/equipment/rentInfo/getaddress`), // 获取所在地
  /** @name 搜索页-获取几个页面的搜索数据 */
  getHomePageTotal: (data) => request.post(`/index/search/getHomePageTotal`, data),
  /** @name 搜索页-获取施工工队列表 */
  // searchTeamList: (data) => request.post(`/index/search/team`, data),
  /** @name 搜索页-获取施工工队列表新 */
  searchTeamList: (data) => request.post(`/index/search/dataBase/team`, data),
  /** @name 搜索页-获取工种报价列表 */
  // searchTeamPrice: (data) => request.post(`/index/search/teamPrice`, data),//v2.1.9注释，跟列表用同一个接口
  /** @name 搜索页-获取找活干列表 */
  searchEngineer: (data) => request.post(`/index/search/engineer`, data),
  /** @name 搜索页-获取找工人列表 */
  // searchWork: (data) => request.post(`/index/search/work`, data),
  searchWork: (data) => request.post(`/worker/list`, data),//v2.1.9更改
  /** @name 搜索页-获取灵活用工列表 */
  searchFlexibleList: (data) => request.post(`/index/search/employment`, data),
  /** @name 搜索页-获取劳务用工列表 */
  searchLabor: (data) => request.post(`/index/search/labor`, data),

  GetVideos: (parms) => request.get(`/team/video/list`, parms), // 施工风采-获取视频
  GetVideoCount: (no) => request.get(`/team/video/update/count/${no}`), // 更新视频播放次数

  /** @name 关注和取消关注 */
  addAttention: (no, type, isAttention) => request.get(`/attention/addAttention?no=${no}&type=${type}&isAttention=${isAttention}`),

  /** @name 是否关注 */
  userFocus: (no, type) => request.get(`/attention/isFocus?no=${no}&type=${type}`),
  /**
   * @description: 建设工人列表
   */
  getWorkerList: () => request.get(),

  getLocationCity: () => request.get(`sysArea/getAllArea?level=2`),
  /** @name 将负责人的省市区编号转换为文字 */
  /*  */
  // getMenuList: () => request.get(process.env.VUE_APP_MENUURL), // 获取菜单
  // getHotKey: () => request.get('/search/getHotkeys')

  getaddEnquire: (params) => request.post(`/teamEnquire/addEnquire`, params), //v2.0.6-新增函询提交
   /** @name 劳务发布新增申请人相关接口 */
  getOrganizational: (id) => request.get(`${apiMaterials}/v1/organization/getOrganization`), // 获取公司组织架构
  getTeamOrganizational: (id) => request.get(`${apiMaterials}/v1/teamOrganization/getTeamOrganization`), // 获取团队组织架构
  getOrganizationalPepole: (id) => request.get(`${apiMaterials}/v1/organization/getUserPageByParentId?org=${id}&current=1&page=1000`),//查询公司人员列表
  getTeamOrganizationalPepole: (id) => request.get(`${apiMaterials}/v1/teamOrganization/getUserPageByParentId?org=${id}&current=1&page=1000`),//查询团队人员列表
  getUserInfo: () => request.get(`${url1}/teamInfo/getDefaultOrganization`), // 获取当前账号身份信息
  //v2.3.2询价发布接口
  addQueryPrice: (data) => request.post(`/queryPrice/addQueryPrice`, data),
  checkQueryPrice: (no) => request.get(`/queryPrice/checkStatus?teamNo=${no}`), //能否询价校验接口
}
